import Head from 'next/head';
import React, { useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

const PaintCost = () => {
  const [unit, setUnit] = useState('Meter/CM');
  const [carpetArea, setCarpetArea] = useState(0);
  const [doorLength, setDoorLength] = useState(0);
  const [doorHeight, setDoorHeight] = useState(0);
  const [numDoors, setNumDoors] = useState(0);
  const [windowLength, setWindowLength] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [numWindows, setNumWindows] = useState(0);
  const [result, setResult] = useState({
    paintAreaSqFt: 0,
    paintAreaSqM: 0,
   
    paintLiters: 0,
    primerLiters: 0,
    puttyKgs: 0,
  });


  const [activeIndex, setActiveIndex] = useState(null); // State to keep track of the active FAQ item index
 const[missingCarpetArea,setMissingCarpetArea] = useState(false);


 const breadCrumbSchema = () => {
  return {
    __html: `{
      "@context": "https://schema.org/", 
      "@type": "BreadcrumbList", 
      "itemListElement": [{
        "@type": "ListItem", 
        "position": 1, 
        "name": "Home",
        "item": "https://www.orientbell.com"
      },{
      "@type": "ListItem", 
      "position": 2, 
      "name": "Paint Cost Calculator",
      "item": "https://www.orientbell.com/paint-cost-calculator"
    }]
    }`
  }
} 


const FaqSchema = () =>{
  return{
    __html :`
    {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "url": "https://www.orientbell.com/tiles/beige-kitchen-tiles",
  "mainEntity": [{
    "@type": "Question",
    "name": "How do you calculate paint area?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Start by adding together the length of all the surfaces to be painted. Multiply it by the height (in case of walls, the measurement from the floor to ceiling). This will provide you with the square footage of the surface to be painted."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I select the right paint for my house?",
    "acceptedAnswer": {
      "@type": "Choosing the right paint for your home will depend upon various factors, such as: 1. The type of paint – satin, matte, glossy finish. Also, the surface you are painting. Metal requires a completely different paint than concrete. 2. Budget 3. Colour – certain colours are only available in certain types of paints 4. Surface prep – do you want a paint + primer in one or just paint"
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much paint do I need for 2 walls?",
    "acceptedAnswer": {
      "@type": "This depends on the size of the walls and the coverage area of the paint. Assuming each wall is about 100 sq. feet, about 2 litres of paint should be required on average."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much paint is required for 1,000 sq ft?",
    "acceptedAnswer": {
      "@type": "By assuming 1 litre of paint can cover 100 sq. feet, for 1,000 sq. feet about 10 litres of paint will be required."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do you calculate square footage for exterior painting?",
    "acceptedAnswer": {
      "@type": "Measure the length and breadth of the walls to be covered and multiply them to determine the square footage of the area to be covered."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How to calculate wall area for painting?",
    "acceptedAnswer": {
      "@type": "Measure the length and breadth of the walls to be covered. Multiply the length and breadth to determine the area."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How to calculate the area of a room for painting?",
    "acceptedAnswer": {
      "@type": "Multiply the length of the room by its breadth to calculate the area for painting."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much does 1 Litre of paint cover?",
    "acceptedAnswer": {
      "@type": "A litre of paint can cover up to 100 sq. feet of area."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What area does 5 Litres of paint cover?",
    "acceptedAnswer": {
      "@type": "Assuming 1 litre of paint can cover up to 100 sq. feet of area, 5 litres of paint will be able to cover 500 sq. feet of area."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much paint is required for 100 sq ft?",
    "acceptedAnswer": {
      "@type": "1 litre of paint is required to cover 100 sq. feet of area."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much paint do I need for a 10x10 room?",
    "acceptedAnswer": {
      "@type": "A 10x10 room measures 100 sq. feet, requiring 1 litre of paint."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How many coats of emulsion are needed?",
    "acceptedAnswer": {
      "@type": "Two coats of emulsion will be sufficient for full coverage."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the maximum time between coats of paint?",
    "acceptedAnswer": {
      "@type": "It is best to wait for four to six hours between two coats of paints. For oil-based paints, it is best to wait for about 24 hours."
    }
  },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the material and labour cost in painting?",
    "acceptedAnswer": {
      "@type": "The cost of labour varies between Rs. 10 per sq. feet to Rs. 200 per sq. feet, depending upon your location, the skill of the labourer, type of paint, and the complexity of your project."
    },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How do I calculate how much paint I need?",
    "acceptedAnswer": {
      "@type": "When it comes to planning the painting work, it is important first to understand the information provided on the can of paint, especially the coverage per litre. Once this has been determined, the next step is to find how much paint is needed by measuring the square surface area."
    },{
    "@type": "Question",
    "acceptedAnswer": {
    "name": "Are painting estimates negotiable?",
    "acceptedAnswer": {
      "@type": "Yes, painting jobs can be negotiable. The cost estimates for painting jobs can change a lot based on the materials used, the difficulty of the job, and the labour involved. This gives customers and estimators a chance to negotiate and possibly change the initial price."
    },
    {
    "@type": "Question",
    "acceptedAnswer": {
    "name": "How much should I budget for paint?",
    "acceptedAnswer": {
      "@type": "It is important to understand that a variety of requirements like the area to be painted, the number of coats to be applied, and the price of paint, are taken into consideration when creating a painting budget. If not, research the typical range of pricing per square foot and adjust them to meet your needs."
    },
    {
    "@type": "Question",
    "acceptedAnswer": {
    "name": "What is the Painting Cost per Square Foot?",
    "acceptedAnswer": {
      "@type": "The main factors that contribute to the total price charged for painting in a given area in square feet are surface preparation, the paint material, the labour involved, the complexity of the job, and then taking into consideration the other different factors that determine the final cost of doing the work."
    }
  }]
}
    `
  }
}




  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };


 

  const handleReset = () => {
    // Reset form input values and result state
    setMissingCarpetArea(false)
    setUnit('Meter/CM');
    setCarpetArea(0);
    setDoorLength(0);
    setDoorHeight(0);
    setNumDoors(0);
    setWindowLength(0);
    setWindowHeight(0);
    setNumWindows(0);
    setResult({
      paintAreaSqFt: 0,
      paintAreaSqM: 0,
      paintLiters: 0,
      primerLiters: 0,
      puttyKgs: 0,
    });
  };


  const calculateArea = (length, width, unit) => {
    if (unit === 'Feet/Inch') {
      return length * width; // Assuming length and width are in feet if unit is Feet/Inch
    } else {
      // Convert length and width to meters if unit is Meter/CM
      const lengthInMeters = length * 0.3048; // 1 foot = 0.3048 meters
      const widthInMeters = width * 0.3048;
      return lengthInMeters * widthInMeters;
    }
  };
  
  const handleCalculate = () => {

    if(!carpetArea){
      setMissingCarpetArea(true)
    }
    // Convert carpetArea to a number
    const carpetAreaInSqFt = parseFloat(carpetArea);
  
    const paintAreaSqFt = carpetAreaInSqFt * 3.5;
  const paintAreaSqM = paintAreaSqFt / 10.7639;
  
    const doorWidthInFeet = parseFloat(doorLength);
    const doorHeightInFeet = parseFloat(doorHeight);
    const windowWidthInFeet = parseFloat(windowLength);
    const windowHeightInFeet = parseFloat(windowHeight);
    const numDoorsCount = parseInt(numDoors);
    const numWindowsCount = parseInt(numWindows);
  
    // Calculate door area in square feet
    const doorArea = doorWidthInFeet * doorHeightInFeet * numDoorsCount;
  
    // Calculate window area in square feet
    const windowArea = windowWidthInFeet * windowHeightInFeet * numWindowsCount;
  
    // Calculate actual paint area in square feet
    const actualPaintArea = paintAreaSqFt - doorArea - windowArea;
  
    // Calculate paint, primer, and putty in liters and kgs
    const paintLiters = actualPaintArea / 100; // 1 liter of paint covers 100 sq.ft
    const primerLiters = actualPaintArea / 100; // 1 liter of primer covers 100 sq.ft
    const puttyKgs = actualPaintArea / 40; // 2.5 kg of putty covers 100 sq.ft

    setResult({
        paintAreaSqFt: paintAreaSqFt.toFixed(2),
        paintAreaSqM: paintAreaSqM.toFixed(2),
        paintLiters: paintLiters.toFixed(2),
        primerLiters: primerLiters.toFixed(2),
        puttyKgs: puttyKgs.toFixed(2),
      });
  
    // Update the state or display the results as needed
  };
  
  

  const faqData = [
    {
      question: 'How do you calculate paint area?',
      answer: 'Start by adding together the length of all the surfaces to be painted. Multiply it by the height (in case of walls, the measurement from the floor to ceiling). This will provide you with the square footage of the surface to be painted.'
    },
    {
      question: 'How do I select the right paint for my house?',
      answer: 'Choosing the right paint for your home will depend upon various factors, such as:\n1. The type of paint – satin, matte, glossy finish. Also, the surface you are painting. Metal requires a completely different paint than concrete.\n2. Budget\n3. Colour – certain colours are only available in certain types of paints\n4. Surface prep – do you want a paint + primer in one or just paint'
    },
    {
      question: 'How much paint do I need for 2 walls?',
      answer: 'This depends on the size of the walls and the coverage area of the paint. Assuming each wall is about 100 sq. feet, about 2 litres of paint should be required on average.'
    },
    {
      question: 'How much paint is required for 1,000 sq ft?',
      answer: 'By assuming 1 litre of paint can cover 100 sq. feet, for 1,000 sq. feet about 10 litres of paint will be required.'
    },
    {
      question: 'How do you calculate square footage for exterior painting?',
      answer: 'Measure the length and breadth of the walls to be covered and multiply them to determine the square footage of the area to be covered.'
    },
    {
      question: 'How to calculate wall area for painting?',
      answer: 'Measure the length and breadth of the walls to be covered. Multiply the length and breadth to determine the area.'
    },
    {
      question: 'How to calculate the area of a room for painting?',
      answer: 'Multiply the length of the room by its breadth to calculate the area for painting.'
    },
    {
      question: 'How much does 1 Litre of paint cover?',
      answer: 'A litre of paint can cover up to 100 sq. feet of area.'
    },
    {
      question: 'What area does 5 Litres of paint cover?',
      answer: 'Assuming 1 litre of paint can cover up to 100 sq. feet of area, 5 litres of paint will be able to cover 500 sq. feet of area.'
    },
    {
      question: 'How much paint is required for 100 sq ft?',
      answer: '1 litre of paint is required to cover 100 sq. feet of area.'
    },
    {
      question: 'How much paint do I need for a 10x10 room?',
      answer: 'A 10x10 room measures 100 sq. feet, requiring 1 litre of paint.'
    },
    {
      question: 'How many coats of emulsion are needed?',
      answer: 'Two coats of emulsion will be sufficient for full coverage.'
    },
    
    
    {
      question: 'What is the maximum time between coats of paint?',
      answer: 'It is best to wait for four to six hours between two coats of paints. For oil-based paints, it is best to wait for about 24 hours.'
    },
    {
      question: 'What is the material and labour cost in painting?',
      answer: 'The cost of labour varies between Rs. 10 per sq. feet to Rs. 200 per sq. feet, depending upon your location, the skill of the labourer, type of paint, and the complexity of your project.'
    },
    {
      question: 'How do I calculate how much paint I need?',
      answer:'When it comes to planning the painting work, it is important first to understand the information provided on the can of paint, especially the coverage per litre. Once this has been determined, the next step is to find how much paint is needed by measuring the square surface area. '
    },
    {
      question:'Are painting estimates negotiable?',
      answer:'Yes, painting jobs can be negotiable. The cost estimates for painting jobs can change a lot based on the materials used, the difficulty of the job, and the labour involved. This gives customers and estimators a chance to negotiate and possibly change the initial price.'
    },
    {
      question:'How much should I budget for paint?',
      answer:'It is important to understand that a variety of requirements like the area to be painted, the number of coats to be applied, and the  price of paint, are taken into consideration when creating a painting budget. If not, research the typical range of pricing per square foot and adjust them to meet your needs.'
    },
    {
      question:'What is the Painting Cost per Square Foot?',
      answer:'The main factors that contribute to the total price charged for painting in a given area in square feet are surface preparation, the paint material, the labour involved, the complexity of the job, and then taking into consideration the other different factors that determine the final cost of doing the work.'
    }
  ];

  return (
    <>
     <Head>
    <title>Paint Cost Calculator | Calculate Painting Cost With Orientbell</title>
	<meta name="title" content="Paint Cost Calculator | Calculate Painting Cost With Orientbell"/>
<meta name="description" content="Estimate your painting costs with Orientbell’s paint calculator. Plan your project budget by calculating paint quantity, total expenses, and paint cost per square foot."/>
<script type="application/ld+json" dangerouslySetInnerHTML={ breadCrumbSchema()}/>
<script type="application/ld+json" dangerouslySetInnerHTML={ FaqSchema()}/>

    </Head>
    <div className="areaCalc-cnvrtrSec-section costestimator">
    <div className="container">
    <Breadcrumb>
      <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
      <Breadcrumb.Item href="#">
      Paint Cost Calculator
      </Breadcrumb.Item>
     
    </Breadcrumb>
      <div className='top-section'>
     
        <h1>Paint Cost Calculator</h1>
        <p>Constructing your home or renovating it, we all want the best paint to be used. However, budgets can go high and get you confused on what to choose. With this in mind, we have developed our paint cost calculator that will help you choose the perfect paint for your walls within your budget. With Orientbell Tiles’ Paint Calculator, you can easily reduce the confusion around which paint to select for the walls of your home.Using a paint calculation formula, this house painting cost calculator will provide you with an approximate estimate in a simple and easy to understand manner.</p>
        {/* <h2>How Do I Calculate How Much Paint I Need?</h2> */}
     
      </div>
      
        <div className="areaCalc-cnvrtrSec-row paintcalculator">
          <h2>Orientbell Tiles Paint Calculator</h2>
          <div className="portlet-body-row">
            <div className="portlet-body-cost"> 
              <label>Unit <i className="fa fa-info-circle" aria-hidden="true"></i></label>
              <div className="portlet-group full-width">
                <select className="form-control" value={unit} onChange={(e) => setUnit(e.target.value)}>
                  <option value="Meter/CM">Meter/CM</option>
                  <option value="Feet/Inch">Feet/Inch</option>
                </select>
              </div>
            </div>

            <div className="portlet-body-cost">
  <label>Carpet Area <i className="fa fa-info-circle" aria-hidden="true"></i></label>
  <div className="portlet-group">
    <input
      type="text"
      className="form-control"
      value={carpetArea}
      onChange={(e) => setCarpetArea(e.target.value)}
    />
    <div className="portlet-group-addon">{unit === 'Feet/Inch' ? 'Sq. ft.' : 'Sq. m.'}</div>
  </div>
</div>


<div className="portlet-body-cost">
  <label>Door Size <i className="fa fa-info-circle" aria-hidden="true"></i></label>
  <div className="obl-work-calculator-row">
    <div className="portlet-group">
      <label>Length</label>
      <input
        type="text"
        className="form-control"
        value={doorLength}
        onChange={(e) => setDoorLength(e.target.value)}
      />
      <div className="portlet-group-addon">{unit === 'Feet/Inch' ? 'ft' : 'm'}</div>
    </div>
    <div className="portlet-group">
      <label>Height</label>
      <input
        type="text"
        className="form-control"
        value={doorHeight}
        onChange={(e) => setDoorHeight(e.target.value)}
      />
      <div className="portlet-group-addon">{unit === 'Feet/Inch' ? 'ft' : 'm'}</div>
    </div>
  </div>
</div>


            <div className="portlet-body-cost">
              <label>No. of Doors <i className="fa fa-info-circle" aria-hidden="true"></i></label>
              <div className="portlet-group">
                <input
                  type="text"
                  className="form-control"
                  value={numDoors}
                  onChange={(e) => setNumDoors(e.target.value)}
                />
                <div className="portlet-group-addon">Nos</div>
              </div>
            </div>

            <div className="portlet-body-cost">
  <label>Window Size <i className="fa fa-info-circle" aria-hidden="true"></i></label>
  <div className="obl-work-calculator-row">
    <div className="portlet-group">
      <label>Length</label>
      <input
        type="text"
        className="form-control"
        value={windowLength}
        onChange={(e) => setWindowLength(e.target.value)}
      />
      <div className="portlet-group-addon">{unit === 'Feet/Inch' ? 'ft' : 'm'}</div>
    </div>
    <div className="portlet-group">
      <label>Height</label>
      <input
        type="text"
        className="form-control"
        value={windowHeight}
        onChange={(e) => setWindowHeight(e.target.value)}
      />
      <div className="portlet-group-addon">{unit === 'Feet/Inch' ? 'ft' : 'm'}</div>
    </div>
  </div>
</div>


            <div className="portlet-body-cost">
              <label>No. of Windows <i className="fa fa-info-circle" aria-hidden="true"></i></label>
              <div className="portlet-group">
                <input
                  type="text"
                  className="form-control"
                  value={numWindows}
                  onChange={(e) => setNumWindows(e.target.value)}
                />
                <div className="portlet-group-addon">Nos</div>
              </div>
            </div>

            <div className="portlet-body-cost form-actions">
              <button className="calculate-button" onClick={handleCalculate}>
                Calculate
              </button>
              <button className="reset-button" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          {result.paintAreaSqFt!=0 ? (
                <div className="result-section">
                  <h2>Painting Calculation Results</h2>
                  <div>
                    <p>
                      Area: {result.paintAreaSqFt} sq.ft ({result.paintAreaSqM} sq.m)
                    </p>
                   
                    <p>Paint: {result.paintLiters} liters</p>
                    <p>Primer: {result.primerLiters} liters</p>
                    <p>Putty: {result.puttyKgs} kgs</p>
                  </div>
                </div>
              )
            :
            missingCarpetArea &&
            <div className="result-section-red">
              <p>Please enter input fields to calculate</p>
              </div>
              
              }
        </div>
      

      <div className='bottom-section-text'>
       
        <h2>How Is Painting Cost Calculated?</h2>
        <p>A paint cost calculator is extremely useful for those who wish to calculate the amount of paint required to cover the surface of a particular area, thereby providing an approximate estimate of the amount the project will cost.</p>
        <p>The following factors need to be considered while calculating the painting cost:</p>
			
		<div className="costesti_sub">
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/measuring-tape-hands-man-template-poster-1496931842"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_8_1.jpg" alt="mesurement of surface area"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>1. Surface Area</h3>
					<p>Take a measurement of the surface to be painted. This can be in square metres or square feet, but keep a note of which. This includes all walls, doors, trims, windows, and other surfaces to be painted.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/paint-brush-roller-bucket-cans-icons-526575151"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_10_1.jpg" alt="paint calculator square feet"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>2. Type of Paint</h3>
					<p>The type of paint you choose will depend upon various factors such as your budget and the surface being painted. Exterior or interior, glossy or matte, textured paint - there are different types of paints available to choose from.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/spilled-red-paint-bucket-vector-430424668"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_9_1.jpg" alt=""/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>3. Coverage Rate Of Paint</h3>
					<p>Coverage rate of paint depends on the thickness or viscosity of the paint. Most paint buckets come with instructions printed that will help you determine the coverage rate per litre. This can help you estimate the amount of paint required.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/home-renovation-man-woman-painting-wall-1284210163"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_7_1.jpg" alt="paint calculator exterior square feet"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>4. Number Of Coats Required</h3>
					<p>Are you simply refreshing your walls or doing an all out paint job? This will help determine if you need one coat, two coats, or even more. This will further impact the amount of paint required.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/paint-buckets-semi-flat-color-vector-2276197745"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_5_1.jpg" alt="Price Of The Paint"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>5. Price Of The Paint</h3>
					<p>Paint is priced per litre, and is sold in different sized buckets. The cost per litre varies according to the type of paint and this information can be determined in store or on the manufacturer’s website.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/painter-on-ladder-painting-wall-man-1747344296"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_2_1.jpg" alt="painting labour cost calculator"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>6. Cost Of Labour</h3>
					<p>The cost of labour can depend on various factors such as your location, the skill of the labourer, do they work hourly/daily or on a project basis, and the complexity of your project. It is best to predetermine this so that there are no surprises in the future.</p>
				</div>
			</div>
            <div className="costestimator-prod-row paintcalculator-text-full">
				<div className="costestimator-prod-text">
					<h3>7. Clean Up</h3>
					<p>Is the cost of clean up included in the painter’s fee, or do you need to pay extra? Cleaning up after painting is messy and could involve stains on the floors or furniture. Make sure you clear this.</p>
				</div>
			</div>    
            <div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/vector-roller-paint-brushes-colors-119231563"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_4_1.jpg" alt="painting cost calculator"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>8. Cost Of Equipment</h3>
					<p>Painting the space involves some basic equipment such as rollers, brushes, tapes and cleaner liquids. The cost of such equipment should be accounted for when budgeting the cost of painting.</p>
					<p>Once all this information has been gathered, you can calculate the cost of painting using the following <strong>paint calculation formula:</strong></p>
					<p>Painting Cost = (Surface Area to Be Covered / Coverage Area of Paint) x Number of Coats Required x Paint Price</p>
					<p>Add to this Cost of Labour and Cost of Additional Material (if any)</p>
					<p>It is important to note that this is a very basic and straightforward way of estimating the rough cost – the actual costs may differ. It is best to invite quotes from professionals to determine a more accurate cost.</p>
				</div>
			</div>      
        </div>        
		<div className="costesti_sub">
			<h2>Essentials Of Home Painting: Coverage Area And Coats For Paint, Primer, And Putty</h2>
			<div className="costestimator-prod-row paintcalculator-text-full">
				<div className="costestimator-prod-text">
					<h3>Primer</h3>
					<p>Primer is a substance that is spread over the surface to be painted so that the paint adheres better. A primer is not the final finish, it is a pre finish to prepare the surface for the paint. Similar to paint, 1 litre of primer can cover almost 100 sq. feet of paintable area.</p>
				</div>
			</div> 
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/open-paint-bucket-vector-240973249"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_6_1.jpg" alt="home painting estimate"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>Paint</h3>
					<p>Paint is usually a liquid substance that is used as a final coat on surfaces as a decorative and protective element. On average, 1 litre of paint can cover almost 100 sq. feet of paintable surface.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/home-repair-interior-remodeling-vector-illustration-1303466776"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_3_1.jpg" alt="putty on minor dents"/></a>
				</div>
				<div className="costestimator-prod-text">
					<h3>Putty</h3>
					<p>Putty is a paste prepared to fill in the gaps and minor dents in order to create a level surface. Often, a putty covered surface needs to be coated with a primer before you can paint it. The amount of putty depends on the surface area that is being painted.</p>
				</div>
			</div>
			<div className="costestimator-prod-row">
				<div className="costestimator-prod-img">
					<a href="https://www.shutterstock.com/image-vector/vector-two-women-painting-wall-isolated-1901979385"><img src="https://images.orientbell.com/media/wysiwyg/850x450_Pix_1_2.jpg" alt="plastic paint price"/></a>
				</div>
				<div className="costestimator-prod-text">
					 <h3>Coverage Area</h3>
					<ul>
						<li>Spray-painting a surface can cover more area than using a roller or a brush.</li>
						<li>To know the exact coverage area of your paint, refer to the manufacturer’s instructions – each paint bucket usually has the coverage area written on it.</li>
					</ul>
				</div>
			</div>
			<div className="costestimator-prod-row paintcalculator-text-full">
				<div className="costestimator-prod-text">
					<h3>Coats</h3>
					<p>A “coat” essentially refers to the layers of paint.</p>
					<ul>
						<li>One coat refers to a single layer of paint. 1 coat is often enough if you are repainting or covering minor damages.</li>
						<li>Two coats refer to two layers of paint. While doing a fresh paint job or changing the colour scheme, 2 coats of paints are required for full coverage.</li>
					</ul>
				</div>
			</div>
		</div>  
		<div className="areacalculator-faq">
			<h2>FAQs</h2>
			<div className="newacd">
				<ul className="accordion">
					{faqData.map((item, index) => (
						<li key={index}>
							<a
							  className={`toggle ${activeIndex === index ? 'active' : ''}`}
							 
							  onClick={() => toggleFaq(index)}
							>
							  {item.question}
							</a>
							{activeIndex === index && (
							  <ul className={`inner show`}>
								<li>{item.answer}</li>
							  </ul>
							)}
						</li>
					))}
				</ul>
			</div>
		</div>
                           
              </div>
              </div>
            </div>
             
        </>
          );
        };

        export default PaintCost;
